import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export const cn = (...inputs: ClassValue[]) => {
  return twMerge(clsx(inputs))
}

/**
 * Formats a calendar Date to "yyyy-MM-dd" using the user's local date (year/month/day).
 *
 * Use this for values from date pickers (react-day-picker uses local calendar days).
 * Do not use UTC calendar parts: in timezones ahead of UTC, local midnight on day N can
 * still fall on UTC day N−1, which would send the wrong date to the API.
 */
export const formatDateLocalISO = (date: Date): string => {
  const y = date.getFullYear()
  const m = String(date.getMonth() + 1).padStart(2, '0')
  const d = String(date.getDate()).padStart(2, '0')
  return `${y}-${m}-${d}`
}

/**
 * Parses an API "yyyy-MM-dd" (or ISO string starting with that date) as a local calendar date.
 * Avoids `new Date("yyyy-MM-dd")` / parseISO, which are interpreted as UTC midnight and shift
 * the calendar day in many timezones.
 */
export const parseApiDateOnly = (value: string): Date => {
  const dateOnly = value.slice(0, 10)
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dateOnly)
  if (!match) {
    return new Date(value)
  }
  const y = Number(match[1])
  const mo = Number(match[2])
  const d = Number(match[3])
  return new Date(y, mo - 1, d)
}
